/**
 * Trademark symbol processor
 * Searches for ® symbols in text content and wraps them in <sup> tags
 */
(function processTrademarks() {
  if (!document.body) return;
  try {
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const parent = node.parentElement;
          if (parent && (parent.tagName === 'SCRIPT' || parent.tagName === 'STYLE')) {
            return NodeFilter.FILTER_REJECT;
          }
          return node.textContent && node.textContent.includes('®') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      }
    );
    const textNodes = [];
    let currentNode = walker.nextNode();
    while (currentNode) {
      textNodes.push(currentNode);
      currentNode = walker.nextNode();
    }
    textNodes.forEach(textNode => {
      if (!textNode || !textNode.textContent || !textNode.parentNode) return;
      const text = textNode.textContent;
      if (text.includes('®')) {
        const parent = textNode.parentElement;
        if (parent && parent.tagName === 'SUP') return;
        const html = text.replace(/®/g, '<sup>®</sup>');
        const wrapper = document.createElement('span');
        wrapper.innerHTML = html;
        textNode.parentNode.replaceChild(wrapper, textNode);
      }
    });
  } catch (error) {
    console.warn('Trademark processing failed:', error);
  }
})(); 